var map = {
	"./arrow-down.svg": "/7LY",
	"./arrow.svg": "7Hhe",
	"./facebook.svg": "85DX",
	"./instagram.svg": "OCqi",
	"./letter.svg": "/N+g",
	"./logo-color.svg": "G8lN",
	"./logo-icon-white.svg": "3f+r",
	"./logo-off-white.svg": "Wx4x",
	"./logo-type-white.svg": "qAKS",
	"./logo-white.svg": "kaZ4",
	"./quotes.svg": "3GQY",
	"./star.svg": "2X4u",
	"./svg.svg": "8viG",
	"./testimonial.svg": "izrt",
	"./wsua-1.svg": "2wWg",
	"./wsua-2.svg": "ElEg",
	"./wsua-3.svg": "/woR",
	"./wsua-4.svg": "QBXE",
	"./wsua-5-old.svg": "q4lN",
	"./wsua-5.svg": "FXH2",
	"./wsua-6.svg": "LiVf",
	"./wsua-7.svg": "8NLN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UFRR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/.*\.svg$
// module id = UFRR
// module chunks = 2